import axios from 'axios'

const API_PATH = 'identities/admins/account_links'

const IdentitiesApi = {
  getSeller: async ({ additionalFilters }) => {
    const path     = `${API_PATH}/search_sellers`
    const response = axios.get(path, { params: additionalFilters })

    return response
  },
  getCustomer: async ({ additionalFilters }) => {
    const path     = `${API_PATH}/search_customers`
    const response = axios.get(path, { params: additionalFilters })

    return response
  },
  getSellerProfile: async (sellerEmail) => {
    const path     = `${API_PATH}/verify_seller`
    const response = axios.get(path, {
      params: {
        seller_email: sellerEmail
      }
    })
    return response
  },
  getCustomerProfile: async (customerEmail) => {
    const path     = `${API_PATH}/verify_customer`
    const response = axios.get(path, {
      params: {
        customer_email: customerEmail
      }
    }
    )
    return response
  },
  accountLink: async (values) => {
    const path     = `${API_PATH}/create_user`
    let body       = {
      account_links: values
    }
    const response = axios.post(path, body)

    return response
  }
}

export default IdentitiesApi
